const HALF_SURVEY_CREW = '1/2 Survey Crew';

/**
 * Returns the effective hours for colour-coding, applying 50% reduction
 * when the cost item is '1/2 Survey Crew'.
 */
export function getEffectiveHours(estimatedHours, costItem) {
  const isHalfCrew = Array.isArray(costItem)
    ? costItem.includes(HALF_SURVEY_CREW)
    : costItem === HALF_SURVEY_CREW;
  return isHalfCrew ? estimatedHours * 0.5 : estimatedHours;
}

/**
 * Returns the colour hex string for a schedule based on effective hours.
 * Thresholds: 0–3 teal, 3–5 blue, 5–8 red, 8+ orange.
 */
export function getScheduleColor(estimatedHours, costItem) {
  const eh = getEffectiveHours(estimatedHours, costItem);
  if (eh > 0 && eh < 3) return '#009688';
  if (eh >= 3 && eh < 5) return '#0089ff';
  if (eh >= 5 && eh < 8) return '#ff0000';
  return '#ff9800';
}

export function getTodoDraftColor(urgency) {
  if (urgency?.toLowerCase() === 'urgent') {
    return '#ff0000'; // red
  }
  return '#0089ff'; // blue
}